import React, { useEffect, useRef, useState } from "react";
import {
  chatWithAI,
  generateDietPlanAI,
  generateYogaPlanAI,
  explainReportAI,
  // explainImageReportAI,
} from "./aiFrontendService";
import configData from "../../config.json";

export default function AIDashboardV3() {
  const [phone, setPhone] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [showRegistrationForm, setShowRegistrationForm] = useState(false);

  const [patientInfo, setPatientInfo] = useState({
    age: "",
    weight: "",
    trimester: "",
    diet: "true",
    allergies: "",
  });

  const [selectedLanguage, setSelectedLanguage] = useState("hindi");
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: Date.now(),
      type: "ai",
      content:
        "नमस्ते! मैं आपकी प्रेगनेंसी के दौरान आपकी मदद के लिए यहाँ हूँ। आप मुझसे कोई भी सवाल पूछ सकती हैं।",
    },
  ]);

  const [showReportModal, setShowReportModal] = useState(false);
  const [reportText, setReportText] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const inputRef = useRef(null);
  const messagesRef = useRef(null);

  useEffect(() => {
    const savedPhone = localStorage.getItem("myprega_phone");
    const saved = localStorage.getItem("myprega_user_info");
    const savedLang = localStorage.getItem("myprega_language");
    if (savedPhone) setPhone(savedPhone);
    if (saved) setPatientInfo(JSON.parse(saved));
    if (savedLang) setSelectedLanguage(savedLang);
  }, []);

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  }, [messages]);

  function addMessage(type, content) {
    setMessages((m) => [
      ...m,
      { id: Date.now() + Math.random(), type, content },
    ]);
  }

  async function handlePhoneContinue() {
    const cleaned = phone.trim();
    if (!/^[6-9]\d{9}$/.test(cleaned)) {
      alert("Please enter a valid 10-digit India phone number.");
      return;
    }

    setIsLoading(true);

    const allUsers = await fetchAllAIUsers();
    const existingUser = allUsers.find((user) => user.phone === cleaned);

    setIsLoading(false);

    if (existingUser) {
      localStorage.setItem("myprega_phone", cleaned);
      setPatientInfo((p) => ({
        ...p,
        name: existingUser.name || "",
        trimester: existingUser.trimester || p.trimester,
      }));
      setIsAuthenticated(true);
      setShowRegistrationForm(false);
    } else {
      setPatientInfo((p) => ({ ...p, phone: cleaned }));
      setShowRegistrationForm(true);
    }
  }

  async function handleRegistrationSubmit() {
    if (!patientInfo.name || !patientInfo.pregnancyWeek) {
      alert("Please enter your Name and current Pregnancy Week.");
      return;
    }

    setIsLoading(true);

    const registrationSuccess = await registerAIUser({
      name: patientInfo.name,
      phone: phone,
      email: patientInfo.pregnancyWeek,
    });

    setIsLoading(false);

    if (registrationSuccess) {
      const week = parseInt(patientInfo.pregnancyWeek);
      const trimester =
        week >= 1 && week <= 13
          ? "1"
          : week >= 14 && week <= 27
          ? "2"
          : week >= 28 && week <= 40
          ? "3"
          : "";

      setPatientInfo((p) => ({
        ...p,
        trimester: trimester,
      }));

      localStorage.setItem("myprega_phone", phone);

      setIsAuthenticated(true);
      setShowRegistrationForm(false);
      addMessage(
        "ai",
        `✅ Welcome, ${patientInfo.name}! Your details are saved. NurtureAI is ready to continue supporting your pregnancy journey`
      );
    }
  }

  async function fetchAllAIUsers() {
    try {
      const response = await fetch(
        `${configData.SERVER_API_URL}/ebookuser/get_All_AI_User`
      );

      if (!response.ok) {
        console.error(`❌ Fetch failed: ${response.status}`);
        return [];
      }
      const data = await response.json();
      return data.data || [];
    } catch (error) {
      console.error("Error fetching all AI users:", error);
      return [];
    }
  }

  // Function to register a new user
  async function registerAIUser(userInfo) {
    try {
      const response = await fetch(
        `${configData.SERVER_API_URL}/ebookuser/insert_AI_Users`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: userInfo.name,
            phone: userInfo.phone,
            email: userInfo.email || "",
            is_AIuser: 1,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message ||
            `Failed to register user. Status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Error registering new AI user:", error);
      alert(`Registration failed: ${error.message}`);
      return null;
    }
  }

  function handlePatientChange(e) {
    const { name, value } = e.target;
    setPatientInfo((p) => ({ ...p, [name]: value }));
  }

  function savePatientInfo() {
    if (!patientInfo.age || !patientInfo.weight || !patientInfo.trimester) {
      addMessage(
        "ai",
        "❌ Please fill age, weight and trimester before saving."
      );
      return;
    }
    localStorage.setItem("myprega_user_info", JSON.stringify(patientInfo));
    localStorage.setItem("myprega_language", selectedLanguage);
    addMessage("ai", "✅ Information saved!");

    setDrawerOpen(false);
  }

  async function sendMessage() {
    const text = inputRef.current?.value?.trim();
    if (!text || isLoading) return;
    addMessage("user", text);
    inputRef.current.value = "";
    const tempId = "temp-" + Date.now();
    setMessages((m) => [
      ...m,
      { id: tempId, type: "ai", content: "Thinking..." },
    ]);
    setIsLoading(true);

    try {
      const response = await chatWithAI({
        text,
        language: selectedLanguage,
        patientInfo,
      });
      setMessages((m) => m.filter((it) => it.id !== tempId));
      addMessage("ai", response);
    } catch (err) {
      console.error("chat error", err);
      setMessages((m) => m.filter((it) => it.id !== tempId));
      addMessage("ai", "❌ Failed to connect to AI.");
    } finally {
      setIsLoading(false);
    }
  }

  function handleKeyPress(e) {
    if (e.key === "Enter") sendMessage();
  }

  // diet plan
  async function onGenerateDietPlan(e) {
    if (isLoading) return;
    if (!patientInfo.age || !patientInfo.weight || !patientInfo.trimester) {
      addMessage(
        "ai",
        "❌ Please save your information first before generating diet plan."
      );
      return;
    }
    const temp = {
      id: "temp-" + Date.now(),
      type: "ai",
      content: "Thinking...",
    };
    setMessages((m) => [...m, temp]);
    const btn = e?.currentTarget;
    const orig = btn?.innerText;
    if (btn) {
      btn.innerText = "Generating...";
      btn.disabled = true;
    }
    setIsLoading(true);
    try {
      const output = await generateDietPlanAI({
        language: selectedLanguage,
        patientInfo,
      });
      addMessage("ai", `🍎 Personalized Diet Plan:\n\n${output}`);
    } catch (err) {
      console.error(err);
      addMessage("ai", "❌ Failed to generate diet plan");
    } finally {
      if (btn) {
        btn.innerText = orig || "Diet Plan";
        btn.disabled = false;
      }
      setIsLoading(false);
    }
  }

  // yoga plan
  async function onGenerateYogaPlan(e) {
    if (isLoading) return;
    if (!patientInfo.age || !patientInfo.weight || !patientInfo.trimester) {
      addMessage(
        "ai",
        "❌ Please save your information first before generating yoga plan."
      );
      return;
    }
    const temp = {
      id: "temp-" + Date.now(),
      type: "ai",
      content: "Thinking...",
    };
    setMessages((m) => [...m, temp]);
    const btn = e?.currentTarget;
    const orig = btn?.innerText;
    if (btn) {
      btn.innerText = "Generating...";
      btn.disabled = true;
    }
    setIsLoading(true);
    try {
      const output = await generateYogaPlanAI({
        language: selectedLanguage,
        patientInfo,
      });
      addMessage("ai", `🧘 Personalized Yoga Plan:\n\n${output}`);
    } catch (err) {
      console.error(err);
      addMessage("ai", "❌ Failed to generate yoga plan");
    } finally {
      if (btn) {
        btn.innerText = orig || "Yoga Plan";
        btn.disabled = false;
      }
      setIsLoading(false);
    }
  }

  async function analyzeReport() {
    if (!reportText.trim()) {
      alert("Please enter report text");
      return;
    }

    setShowReportModal(false);

    if (isLoading) return;

    addMessage("ai", "🔎 Analyzing report...");
    setIsLoading(true);

    try {
      const output = await explainReportAI({
        fileBase64: null,
        fileType: null,
        language: selectedLanguage,
        reportText: reportText,
      });

      addMessage("ai", `📊 Report Analysis:\n\n${output}`);
    } catch (err) {
      console.error("REPORT ERROR:", err);
      addMessage("ai", "❌ Failed to analyze report");
    } finally {
      setIsLoading(false);
      setReportText("");
    }
  }

  function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }

  async function handleReportFile(file) {
    if (!file) return alert("Invalid file.");

    setShowReportModal(false);
    setIsLoading(true);
    addMessage("ai", "📄 Processing your report…");

    try {
      const dataUrl = await convertFileToBase64(file);

      const output = await explainReportAI({
        fileBase64: dataUrl,
        fileType: file.type,
        language: selectedLanguage,
      });

      addMessage("ai", `📊 Report Analysis:\n\n${output}`);
    } catch (err) {
      console.error("FILE ERROR:", err);
      addMessage("ai", "❌ Failed to process the file.");
    } finally {
      setIsLoading(false);
    }
  }

  const [isListening, setIsListening] = useState(false);
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  const recog = SpeechRecognition ? new SpeechRecognition() : null;

  if (recog) {
    recog.lang = selectedLanguage === "english" ? "en-IN" : "hi-IN";
    recog.continuous = false;
    recog.interimResults = false;
    recog.maxAlternatives = 1;

    recog.onresult = (event) => {
      const text = event.results[0][0].transcript;
      inputRef.current.value = text;
    };

    recog.onerror = (event) => {
      console.error("Voice error:", event.error);
      addMessage("ai", "❌ Sorry, I couldn't hear you clearly.");
    };
  }

  function startListening() {
    if (!recog) {
      alert("Voice input not supported in this browser!");
      return;
    }

    setIsListening(true);
    recog.start();

    recog.onend = () => setIsListening(false);
  }

  return (
    <div
      className="myprega-app"
      style={{ fontFamily: "Inter, Arial, sans-serif", padding: 20 }}
    >
      <style>{`
        :root {
          --pink: #f3c6d6;
          --pink-strong: #dd90b1;
          --accent: #e46b98;
          --muted: #9a9a9a;
          --card-bg: #fff;
          --radius: 14px;
        }


        .grid {
          display: grid;
          grid-template-columns: 380px 1fr;
          gap: 18px;
        }

        @media (max-width: 980px) {
          .grid { grid-template-columns: 1fr; }
          .left-pane { display: none; }
        }


        .phone-card {
          max-width: 520px;
          margin: 32px auto;
          background: var(--card-bg);
          border-radius: 18px;
          padding: 28px;
          box-shadow: 0 80px 80px rgba(200, 150, 180, 0.08);
          text-align: center;
        }

       
        .left-pane {
          background: var(--card-bg);
          border-radius: var(--radius);
          padding: 18px;
          box-shadow: 0 6px 20px rgba(220, 160, 190, 0.06);
        }

        
        
         .chat-pane {
          background: var(--card-bg);
          border-radius: calc(var(--radius) + 6px);
          padding: 5px;
          height: 90vh;           
          max-height: 100%;  
          max-width: auto; 
          min-width: 310px;  
          min-height: 640px;   
          overflow-y: auto;
          box-shadow: 0 8px 30px rgba(200, 150, 180, 0.04);
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        //   @media (min-width: 768px) {
        //   .chat-pane {
        //     height: 100vh;            
        //   }
        // }

        .chat-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          margin-bottom: 1px;
        }

        
        .hamburger-btn {
          display: none;
          font-size: 22px;
          background: none;
          border: none;
          cursor: pointer;
        }

        @media (max-width: 980px) {
          .hamburger-btn {
            display: inline-block;
          }
        }


     .messages {
          flex: 1;
          overflow-y: auto;
          
          display: flex;
          flex-direction: column;
          gap: 14px;
          padding: 14px;
        
          border-radius: 12px;
          border: 3px solid #f1e7ea;
          background: #ffffff;
          font-size: 12px; 
        }
          
        @media (min-width: 768px) {
          .messages {
            font-size: 14px;           
          }
        }


        .msg {
          max-width: 85%;
          padding: 12px 14px;
          border-radius: 14px;
          white-space: pre-wrap;
          word-wrap: break-word;
          line-height: 1.5;
          display: inline-block;
          margin-bottom: 10px;
          overflow: visible;
        }

        
        .msg.ai {
          background: #fff0f6;
          border: 1px solid #f5dbe4;
          color: #333;
          align-self: flex-start;
          width: auto;       
          height: auto;      
          max-width: 80%;  
        }

        
        .msg.user {
          background: linear-gradient(90deg, var(--accent), var(--pink-strong));
          color: #fff;
          align-self: flex-end;
          text-align: right;
          width: auto;      
          height: auto;     
          max-width: 80%;  
        }

        .msg.urgent {
          background: #ffefef;
          border: 1px solid #f5c2c2;
          color: #7a1f1f;
        }

        .input-row {
          display: flex;
          gap: 8px;
          margin-top: 8px;
        }

        .chat-input {
          flex: 1;
          padding: 12px;
          border-radius: 999px;
          border: 3px solid #eee;
          min-width: 210px;  
        }

        .send-btn {
          padding: 10px 12px;
          border-radius: 100%;
          background: var(--accent);
          color: white;
          border: none;
          cursor: pointer;
          
        }
        .send-btn svg {
          display: block;
          margin: auto;
        }

        .loading-dots {
          display: flex;
          gap: 3px;
        }
        
        .loading-dots span {
          display: inline-block;
          font-size: 20px;
          color: white;
          animation: bounce 0.6s infinite alternate;
        }
        
        .loading-dots span:nth-child(2) {
          animation-delay: 0.2s;
        }
        
        .loading-dots span:nth-child(3) {
          animation-delay: 0.4s;
        }
        
        @keyframes bounce {
          0% {
            transform: translateY(0);
            opacity: 0.5;
          }
          100% {
            transform: translateY(-6px);
            opacity: 1;
          }
        }
        
        .drawer-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          display: flex;
          z-index: 500;
        }

        .drawer {
          width: 78%;
          max-width: 340px;
          height: 100%;
          background: #fff;
          padding: 18px;
          box-shadow: 0 10px 35px rgba(0,0,0,0.15);
          transform: translateX(-100%);
          animation: slideIn 0.28s forwards ease-out;
          overflow-y: auto;
        }

        .drawer .close-btn {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          float: right;
        }

        @keyframes slideIn {
          to { transform: translateX(0); }
        }


        @media (max-width: 480px) {
          .drawer { width: 88%; }
        }

        .mobile-actions {
          display: none;
        }
        @media (max-width: 980px) {
          .mobile-actions {
            display: flex;
            gap: 8px;
            margin-top: 5px;
            margin-bottom: 1px;
          }
          .mobile-actions button {
            flex: 1;
            padding: 7px 8px;
            border-radius: 12px;
            border: none;
            font-weight: 600;
            cursor: pointer;
          }
          .mobile-actions .diet-btn {
            background: linear-gradient(90deg, #f6a4c3, #e46b98);
            color: white;
          }
          .mobile-actions .yoga-btn {
            background: linear-gradient(90deg, #b8e3c6, #7fd29a);
            color: #0b4b2a;
          }
          .mobile-actions .report-btn {
            background: linear-gradient(90deg, #dfe7ff, #9fb7ff);
            color: #08306b;
          }
        }

        .mic-btn {
            padding: 10px 12px;
            border-radius: 999px;
            background: #ffe6f1;
            border: 1px solid #ff8ec0;
            cursor: pointer;
            font-size: 20px;
          }
          
          .mic-btn:hover {
            background: #ffcfe7;
          }

          /* Listening animation */
           .mic-inside.listening {
             background: #ff4fa3;
             padding: 6px;
             border-radius: 50%;
             box-shadow: 0 0 8px rgba(255, 79, 163, 0.7);
             animation: micPulse 1.1s infinite ease-in-out;
           }
           
           .mic-inside.listening svg {
             stroke: #fff;
           }
           
           @keyframes micPulse {
             0% { transform: translateY(-50%) scale(1); }
             50% { transform: translateY(-50%) scale(1.15); }
             100% { transform: translateY(-50%) scale(1); }
           }

          .phone-input-group {
            display: flex;
            gap: 8px;
            justify-content: center;
            align-items: center; 
          }
   
          @media (max-width: 480px) {
            .phone-input-group {
              flex-direction: column; 
              gap: 12px; 
            }
            .phone-input-group input,
            .phone-input-group button {
              width: 100% !important; 
              max-width: 300px; 
            }
          }


      `}</style>

      <div className="container">
        {!isAuthenticated ? (
          <>
            {!showRegistrationForm ? (
              <div
                className="phone-card"
                role="dialog"
                aria-label="Phone login"
              >
                <div style={{ marginBottom: 12 }}>
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: 12,
                      background:
                        "linear-gradient(135deg,var(--pink-strong),var(--accent))",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src="/NurtureAI.png"
                      alt="NurtureAI icon"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 10,
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <h2 style={{ margin: 0, fontWeight: "bold", fontSize: "24px" }}>
                  Welcome to Myprega NurtureAI
                </h2>
                <p style={{ color: "var(--muted)", paddingBottom: "10px" }}>
                  Your 24×7 trusted pregnancy companion — always here to guide,
                  comfort, and support you.
                </p>
                <p style={{ color: "var(--muted)" }}>
                  Enter your phone number to continue
                </p>

                <div className="phone-input-group" style={{ marginTop: 12 }}>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value.replace(/[^0-9]/g, ""))
                    }
                    placeholder="10-digit phone number"
                    maxLength={10}
                    // Removed fixed width (width: 220) to allow CSS class to control it
                    style={{
                      padding: 12,
                      borderRadius: 10,
                      border: "3px solid #eee",
                    }}
                    disabled={isLoading}
                  />
                  <button
                    onClick={handlePhoneContinue}
                    disabled={isLoading}
                    style={{
                      padding: "12px 18px",
                      borderRadius: 12,
                      border: "none",
                      background:
                        "linear-gradient(180deg,var(--accent),var(--pink-strong))",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    {isLoading ? "Checking..." : "Continue"}
                  </button>
                </div>
                <p style={{ color: "var(--muted)", fontSize: "12px" }}>
                  We use your number to give you secure access to personalised
                  pregnancy guidance from NurtureAI.
                </p>
              </div>
            ) : (
              <div
                className="phone-card"
                role="dialog"
                aria-label="New User Registration"
              >
                <div style={{ marginBottom: 12 }}>
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: 12,
                      background:
                        "linear-gradient(135deg,var(--pink-strong),var(--accent))",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src="/NurtureAI.png"
                      alt="NurtureAI icon"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 10,
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <h2 style={{ margin: 0 }}>Let’s Get to Know You</h2>
                <p style={{ color: "var(--muted)" }}>
                  So NurtureAI can give you accurate, personalised pregnancy
                  care, tell us a little about you.
                </p>

                <div style={{ marginTop: 18 }}>
                  <label
                    style={{
                      display: "block",
                      fontWeight: 600,
                      marginBottom: 6,
                      color: "#555",
                      fontSize: 13,
                      textAlign: "left",
                    }}
                  >
                    Your Name
                  </label>
                  <input
                    name="name"
                    type="text"
                    value={patientInfo.name}
                    onChange={handlePatientChange}
                    placeholder="Full Name"
                    style={{
                      width: "100%",
                      padding: 12,
                      borderRadius: 10,
                      border: "1px solid #eee",
                      marginBottom: 12,
                    }}
                  />
                </div>

                <div style={{ marginBottom: 18 }}>
                  <label
                    style={{
                      display: "block",
                      fontWeight: 600,
                      marginBottom: 6,
                      color: "#555",
                      fontSize: 13,
                      textAlign: "left",
                    }}
                  >
                    Current Pregnancy Week
                  </label>
                  <input
                    name="pregnancyWeek"
                    type="number"
                    value={patientInfo.pregnancyWeek}
                    onChange={handlePatientChange}
                    placeholder="e.g., 12"
                    min="1"
                    max="40"
                    style={{
                      width: "100%",
                      padding: 12,
                      borderRadius: 10,
                      border: "1px solid #eee",
                    }}
                  />
                </div>
                <p
                  style={{
                    color: "var(--muted)",
                    fontSize: "12px",
                    paddingBottom: "10px",
                  }}
                >
                  Knowing your pregnancy week helps NurtureAI guide you with
                  safer, stage-appropriate answers.
                </p>

                <button
                  onClick={handleRegistrationSubmit}
                  disabled={isLoading}
                  style={{
                    padding: "12px 18px",
                    borderRadius: 12,
                    border: "none",
                    background:
                      "linear-gradient(180deg,var(--accent),var(--pink-strong))",
                    color: "white",
                    fontWeight: 600,
                    width: "100%",
                  }}
                >
                  {isLoading
                    ? "Registering..."
                    : "Start Your Pregnancy Guidance"}
                </button>

                <div
                  style={{ marginTop: 18, color: "var(--muted)", fontSize: 12 }}
                >
                  Your phone number: **{phone}**
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="grid" role="main">
            <aside
              className="left-pane"
              aria-label="Patient Info & Quick Actions"
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  style={{
                    width: 65,
                    height: 65,
                    borderRadius: 12,
                    background:
                      "linear-gradient(135deg,var(--pink-strong),var(--accent))",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src="/NurtureAI.png"
                    alt="NurtureAI icon"
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: 10,
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 16 }}>
                    Hi {patientInfo.name}
                  </div>
                  <div style={{ color: "var(--muted)", fontSize: 13 }}>
                    {phone}
                  </div>
                </div>
              </div>

              <div style={{ height: 12 }} />

              <div
                style={{
                  fontWeight: 700,
                  color: "#333",
                  marginBottom: 8,
                  fontSize: 16,
                }}
              >
                Your Pregnancy Profile
              </div>
              <div
                style={{
                  fontSize: window.innerWidth < 768 ? 8 : 12,
                  color: "var(--muted)",
                }}
              >
                Your pregnancy is unique. Add your details to help me understand
                you better and give advice that fits your body, your stage, and
                your needs.
              </div>

              <div style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: "block",
                    fontWeight: 600,
                    marginBottom: 6,
                    color: "#555",
                    fontSize: 13,
                  }}
                >
                  Age
                </label>
                <input
                  name="age"
                  type="number"
                  value={patientInfo.age}
                  onChange={handlePatientChange}
                  placeholder="e.g., 26"
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 10,
                    border: "1px solid #eee",
                  }}
                />
              </div>

              <div style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: "block",
                    fontWeight: 600,
                    marginBottom: 6,
                    color: "#555",
                    fontSize: 13,
                  }}
                >
                  Weight (kg)
                </label>
                <input
                  name="weight"
                  type="number"
                  value={patientInfo.weight}
                  onChange={handlePatientChange}
                  placeholder="e.g., 60.5"
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 10,
                    border: "1px solid #eee",
                  }}
                />
              </div>

              <div style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: "block",
                    fontWeight: 600,
                    marginBottom: 6,
                    color: "#555",
                    fontSize: 13,
                  }}
                >
                  Trimester
                </label>
                <select
                  name="trimester"
                  value={patientInfo.trimester}
                  onChange={handlePatientChange}
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 10,
                    border: "1px solid #eee",
                  }}
                >
                  <option value="">Select Trimester</option>
                  <option value="1">First Trimester (1-3 months)</option>
                  <option value="2">Second Trimester (4-6 months)</option>
                  <option value="3">Third Trimester (7-9 months)</option>
                </select>
              </div>

              <div style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: "block",
                    fontWeight: 600,
                    marginBottom: 6,
                    color: "#555",
                    fontSize: 13,
                  }}
                >
                  Diet Preference
                </label>
                <select
                  name="diet"
                  value={patientInfo.diet}
                  onChange={handlePatientChange}
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 10,
                    border: "1px solid #eee",
                  }}
                >
                  <option value="true">Vegetarian</option>
                  <option value="false">Non-Vegetarian</option>
                </select>
              </div>

              <div style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: "block",
                    fontWeight: 600,
                    marginBottom: 6,
                    color: "#555",
                    fontSize: 13,
                  }}
                >
                  Allergies (optional)
                </label>
                <input
                  name="allergies"
                  type="text"
                  value={patientInfo.allergies}
                  onChange={handlePatientChange}
                  placeholder="e.g., nuts, dairy"
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 10,
                    border: "1px solid #eee",
                  }}
                />
              </div>

              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <button
                  onClick={savePatientInfo}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 10,
                    border: "none",
                    cursor: "pointer",
                    background:
                      "linear-gradient(90deg,var(--accent),var(--pink-strong))",
                    color: "#fff",
                  }}
                >
                  Save Information
                </button>
              </div>

              <div style={{ height: 16 }} />

              <div
                style={{
                  fontWeight: 700,
                  color: "#333",
                  marginBottom: 8,
                  fontSize: 16,
                }}
              >
                Quick Actions
              </div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <div
                  onClick={onGenerateDietPlan}
                  style={{
                    flex: "1 1 140px",
                    background: "#fff",
                    borderRadius: 12,
                    padding: 12,
                    border: "3px solid #faf0f4",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  <h5 style={{ margin: 4 }}>🍎 Diet Plan</h5>
                  <div style={{ fontSize: 12, color: "var(--muted)" }}>
                    Personalized meal recommendations
                  </div>
                </div>
                <div
                  onClick={onGenerateYogaPlan}
                  style={{
                    flex: "1 1 140px",
                    background: "#fff",
                    borderRadius: 12,
                    padding: 12,
                    border: "3px solid #faf0f4",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  <h5 style={{ margin: 4 }}>🧘 Yoga Plan</h5>
                  <div style={{ fontSize: 12, color: "var(--muted)" }}>
                    Safe exercises per trimester
                  </div>
                </div>
                <div
                  onClick={() => setShowReportModal(true)}
                  style={{
                    flex: "1 1 140px",
                    background: "#fff",
                    borderRadius: 12,
                    padding: 12,
                    border: "3px solid #faf0f4",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  <h5 style={{ margin: 4 }}>📊 Report Analysis</h5>
                  <div style={{ fontSize: 12, color: "var(--muted)" }}>
                    Upload or paste report
                  </div>
                </div>
              </div>
            </aside>

            {/* Chat pane */}
            <section className="chat-pane" aria-label="AI Chat">
              <div className="chat-header">
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {/* hamburger only visible on mobile */}
                  <button
                    className="hamburger-btn"
                    onClick={() => setDrawerOpen(true)}
                    aria-label="Open menu"
                  >
                    ☰
                  </button>
                  <div>
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: window.innerWidth < 768 ? 14 : 24,
                      }}
                    >
                      Myprega NurtureAI
                    </div>

                    <div
                      style={{
                        fontSize: window.innerWidth < 768 ? 10 : 14,
                        color: "var(--muted)",
                      }}
                    >
                      Your 24×7 Personal Pregnancy Doctor—Always Listening,
                      Always There
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select
                    value={selectedLanguage}
                    onChange={(e) => {
                      setSelectedLanguage(e.target.value);
                      localStorage.setItem("myprega_language", e.target.value);
                    }}
                    style={{
                      padding: 8,
                      borderRadius: 10,
                      border: "1px solid #eee",
                    }}
                  >
                    <option value="hindi">हिंदी</option>
                    <option value="english">English</option>
                    <option value="bengali">বাংলা</option>
                    <option value="tamil">தமிழ்</option>
                    <option value="telugu">తెలుగు</option>
                    <option value="marathi">मराठी</option>
                    <option value="gujarati">ગુજરાતી</option>
                    <option value="punjabi">ਪੰਜਾਬੀ</option>
                  </select>
                </div>
              </div>

              <div ref={messagesRef} className="messages" aria-live="polite">
                {messages.map((m) => (
                  <div
                    key={m.id}
                    className={
                      "msg " +
                      (m.type === "user"
                        ? "user"
                        : m.type === "urgent"
                        ? "urgent"
                        : "ai")
                    }
                    dangerouslySetInnerHTML={{
                      __html: (m.type === "ai"
                        ? m.content + ""
                        : m.content
                      ).replace(/\n/g, "<br/>"),
                    }}
                  />
                ))}
              </div>

              <div
                className="mobile-actions"
                role="group"
                aria-label="Quick actions"
              >
                <button
                  className="diet-btn"
                  onClick={onGenerateDietPlan}
                  aria-label="Diet plan"
                >
                  🍎 Diet
                </button>
                <button
                  className="yoga-btn"
                  onClick={onGenerateYogaPlan}
                  aria-label="Yoga plan"
                >
                  🧘 Yoga
                </button>
                <button
                  className="report-btn"
                  onClick={() => setShowReportModal(true)}
                  aria-label="Report analysis"
                >
                  📊 Report
                </button>
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 6,
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      color: "var(--muted)",
                      paddingLeft: "8px",
                    }}
                  >
                    This tool is not a medical diagnosis. It is a screening
                    test. Always consult a doctor if unsure.
                  </div>
                </div>

                <div className="input-row">
                  <input
                    ref={inputRef}
                    placeholder="Ask anything about your Pregnancy health..."
                    onKeyDown={handleKeyPress}
                    className="chat-input"
                  />
                  <button
                    onClick={startListening}
                    className={`mic-inside ${isListening ? "listening" : ""}`}
                    aria-label="Voice input"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#555"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 1C10.3 1 9 2.3 9 4V12C9 13.7 10.3 15 12 15C13.7 15 15 13.7 15 12V4C15 2.3 13.7 1 12 1Z"></path>
                      <path d="M19 10V12C19 15.9 15.9 19 12 19C8.1 19 5 15.9 5 12V10"></path>
                      <line x1="12" y1="19" x2="12" y2="23"></line>
                      <line x1="8" y1="23" x2="16" y2="23"></line>
                    </svg>
                  </button>
                  <button
                    onClick={sendMessage}
                    disabled={isLoading}
                    className="send-btn"
                  >
                    {isLoading ? (
                      <span className="loading-dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                      </span>
                    ) : (
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="22" y1="2" x2="11" y2="13" />
                        <polygon points="22 2 15 22 11 13 2 9" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>

      {drawerOpen && (
        <div className="drawer-overlay" onClick={() => setDrawerOpen(false)}>
          <div className="drawer" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-btn"
              onClick={() => setDrawerOpen(false)}
              aria-label="Close"
            >
              ×
            </button>
            <h3 style={{ marginTop: 4 }}>Your Pregnancy Profile</h3>
            <div
              style={{
                fontSize: window.innerWidth < 768 ? 8 : 12,
                color: "var(--muted)",
              }}
            >
              Your pregnancy is unique. Add your details to help me understand
              you better and give advice that fits your body, your stage, and
              your needs.
            </div>

            <div style={{ marginTop: 12 }}>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Age
              </label>
              <input
                name="age"
                type="number"
                value={patientInfo.age}
                onChange={handlePatientChange}
                placeholder="e.g., 26"
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Weight (kg)
              </label>
              <input
                name="weight"
                type="number"
                value={patientInfo.weight}
                onChange={handlePatientChange}
                placeholder="e.g., 60.5"
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Trimester
              </label>
              <select
                name="trimester"
                value={patientInfo.trimester}
                onChange={handlePatientChange}
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              >
                <option value="">Select Trimester</option>
                <option value="1">First Trimester (1-3 months)</option>
                <option value="2">Second Trimester (4-6 months)</option>
                <option value="3">Third Trimester (7-9 months)</option>
              </select>
            </div>

            <div style={{ marginTop: 10 }}>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Diet Preference
              </label>
              <select
                name="diet"
                value={patientInfo.diet}
                onChange={handlePatientChange}
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              >
                <option value="true">Vegetarian</option>
                <option value="false">Non-Vegetarian</option>
              </select>
            </div>

            <div style={{ marginTop: 10 }}>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Allergies (optional)
              </label>
              <input
                name="allergies"
                type="text"
                value={patientInfo.allergies}
                onChange={handlePatientChange}
                placeholder="e.g., nuts, dairy"
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              />
            </div>

            <div
              style={{
                marginTop: 14,
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
              }}
            >
              <button
                onClick={() => {
                  setDrawerOpen(false);
                }}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  background: "#ddd",
                  border: "none",
                }}
              >
                Cancel
              </button>
              <button
                onClick={savePatientInfo}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  background:
                    "linear-gradient(90deg,var(--accent),var(--pink-strong))",
                  color: "#fff",
                  border: "none",
                }}
              >
                {" "}
                Save
              </button>
            </div>

            <hr style={{ margin: "16px 0" }} />

            <div style={{ display: "flex", gap: 10, flexDirection: "column" }}>
              <button
                onClick={onGenerateDietPlan}
                style={{
                  padding: 12,
                  borderRadius: 10,
                  border: "3px solid #eee",
                  background: "#fff",
                }}
              >
                🍎 Diet Plan
              </button>
              <button
                onClick={onGenerateYogaPlan}
                style={{
                  padding: 12,
                  borderRadius: 10,
                  border: "3px solid #eee",
                  background: "#fff",
                }}
              >
                🧘 Yoga Plan
              </button>
              <label
                style={{
                  display: "block",
                  marginTop: 6,
                  fontSize: 13,
                  color: "var(--muted)",
                }}
              >
                Upload report (image / pdf)
              </label>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.pdf"
                onChange={(e) => handleReportFile(e.target.files[0])}
              />
            </div>
          </div>
        </div>
      )}

      {showReportModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 60,
          }}
        >
          <div
            style={{
              background: "white",
              padding: 18,
              borderRadius: 12,
              width: "90%",
              maxWidth: 520,
            }}
          >
            <h3>Upload Medical Report</h3>
            <textarea
              value={reportText}
              onChange={(e) => setReportText(e.target.value)}
              placeholder="Paste your report text here..."
              style={{
                width: "100%",
                minHeight: 160,
                borderRadius: 8,
                padding: 10,
                border: "1px solid #eee",
              }}
            />
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.pdf"
              onChange={(e) => handleReportFile(e.target.files[0])}
              style={{
                width: "100%",
                marginTop: "10px",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                marginTop: 12,
              }}
            >
              <button
                onClick={() => {
                  setShowReportModal(false);
                  setReportText("");
                }}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  background: "#ddd",
                  border: "none",
                }}
              >
                Cancel
              </button>
              <button
                onClick={analyzeReport}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  background:
                    "linear-gradient(90deg,var(--accent),var(--pink-strong))",
                  color: "#fff",
                  border: "none",
                }}
              >
                Analyze Report
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
